import { useCourses } from "../../assets/api/UseStudentGetApi";

import { useEffect } from "react";

export const useProcessedCourses = (filter) => {
  const {
    data,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
  } = useCourses(filter);

  // Auto fetch all pages
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const pages = data?.pages?.flatMap((page) => page?.data) || [];
  
  const excludedTypes = [5, 8, 9, 10];

  return {
    pages,
    isLoading,

    normalCourses: pages.filter(course => !excludedTypes.includes(course?.type)) || [],

    skill2SchoolCourses: pages.filter(
      (course) =>
        course?.type === 8 &&
        course?.upskill === 0 &&
        course?.is_camp === null
    ),

    upSkill4TeacherCourses: pages.filter(
      (course) =>
        course?.type === 8 &&
        course?.upskill === 1
    ),

    campCourses: pages.filter(
      (course) =>
        course?.type === 8 &&
        (course?.is_camp === "teachers" ||
          course?.is_camp === "both")
    ),
  };
};
